<template lang="pug">
  #communications-center
    BCollapse.card(
      aria-id="createNewEmail"
      :open.sync="createNewEmailOpen"
      class="custom-collapse"
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='createNewEmail'
        :class="createNewEmailOpen ? 'no-box-shadow' : 'box-shadow-transition'"
      )
        .card-header-title
          WtTitle(card-title-large) Send Email
        a.card-header-icon
          BIcon(:icon="createNewEmailOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      BTabs.px-5.custom-tabs(
        v-model="activeTab"
        size="is-medium"
        @input="tabSelected"
      )
        BTabItem(
          :key="0"
          label="Create Email"
        )
          MemberCenterAdminCreateNewEmail.px-0(
            :featured-challenges="allFeaturedChallenges"
          )
        BTabItem(
          :key="1"
          label="Email Archive"
        )
          MemberCenterAdminEmailArchive(
            :archived-emails="archivedEmails"
            :archived-emails-loaded="archivedEmailsLoaded"
            :fetch-action="fetchArchived"
            :featured-challenges="allFeaturedChallenges"
          )
      BLoading(
        :active="!allFeaturedChallengesLoaded"
        :is-full-page="false"
      )
    .level
    BCollapse.card(
      aria-id="pushNotifications"
      :open.sync="pushNotificationsOpen"
      class="custom-collapse"
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='pushNotifications'
        :class="pushNotificationsOpen ? 'no-box-shadow' : 'box-shadow-transition'"
      )
        .card-header-title
          span
            WtTitle(card-title-large) Push Notifications
        a.card-header-icon
          BIcon(:icon="pushNotificationsOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      AdminPushNotifications
    .level
    BCollapse.card(
      aria-id="createNotice"
      :open.sync="createNoticeOpen"
      class="custom-collapse"
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='createNotice'
      )
        .card-header-title
          span
            WtTitle(card-title-large) Member Notices
          WtTooltip(:text="titleTooltip" class="custom-tooltip")
        a.card-header-icon
          BIcon(:icon="createNoticeOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      BTabs.px-5.custom-tabs(
        v-model="activeNoticeTab"
        size="is-medium"
      )
        BTabItem(
          :key="0"
          label="Create New"
        )
          MemberCenterAdminCreateNotice(
            :notice="noticeToEdit"
            v-if="programNoticesLoaded"
            :editNoticeMode="editNoticeMode"
            :goBackToNoticeList="goBackToNoticeList"
          )
        BTabItem(
          :key="1"
          label="Active Notices"
        )
          MemberCenterAdminActiveNoticesList(
            :notices="programNotices"
            v-if="programNoticesLoaded"
            :editNotice="editNotice"
          )
    BCollapse.card.my-5(
      aria-id="questions"
      :open.sync="questionsOpen"
      class="custom-collapse"
      animation=""
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='questions'
      )
        .card-header-title
          WtTitle(card-title-large) Questions
        a.card-header-icon
          BIcon(:icon="questionsOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      .column
        ProgramQuestions
    BCollapse.card.my-5.challenge-report-card(
      aria-id="userComments"
      :open.sync="userCommentsOpen"
      animation=""
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='userComments'
      )
        .card-header-title
          WtTitle(card-title-large) User Comments
        a.card-header-icon
          BIcon(:icon="userCommentsOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      .column
        MemberCenterAdminUserComments
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import MemberCenterAdminCreateNewEmail from "@@/MemberCenterAdmin/MemberCenterAdminCreateNewEmail";
import MemberCenterAdminInviteNew from "@@/MemberCenterAdmin/MemberCenterAdminInviteNew";
import MemberCenterAdminCreateNotice from "@@/MemberCenterAdmin/MemberCenterAdminCreateNotice";
import MemberCenterAdminEmailArchive from "@@/MemberCenterAdmin/MemberCenterAdminEmailArchive";
import MemberCenterAdminActiveNoticesList from "@@/MemberCenterAdmin/MemberCenterAdminActiveNoticesList";
import WtTooltip from "@@/WtTooltip/WtTooltip";
import ProgramQuestions from "@@/ProgramQuestionsAdmin/ProgramQuestions";
import MemberCenterAdminUserComments from "@@/MemberCenterAdmin/MemberCenterAdminUserComments";
import AdminPushNotifications from "@@/MemberCenterAdmin/AdminPushNotifications";

export default {
  name: "CommunicationsCenter",

  components: {
    WtTile,
    WtTitle,
    WtTooltip,
    MemberCenterAdminCreateNewEmail,
    MemberCenterAdminInviteNew,
    MemberCenterAdminCreateNotice,
    MemberCenterAdminEmailArchive,
    MemberCenterAdminActiveNoticesList,
    ProgramQuestions,
    MemberCenterAdminUserComments,
    AdminPushNotifications
  },

  mixins: [analyticsTrackingMixin],

  data() {
    return {
      perPage: 5,
      createNewEmailOpen: false,
      createNoticeOpen: false,
      activeTab: 0,
      archivedEmails: {},
      archivedEmailsLoaded: false,
      errorRetrievingEmail: false,
      noticeToEdit: null,
      activeNoticeTab: 1,
      editNoticeMode: false,
      questionsOpen: false,
      userCommentsOpen: false,
      pushNotificationsOpen: false
    };
  },

  computed: {
    ...mapGetters("program", [
      "adminMembersResponseObject",
      "membersLoaded",
      "membersInitialLoadComplete",
      "allFeaturedChallenges",
      "allFeaturedChallengesLoaded"
    ]),
    ...mapGetters("notices", ["programNotices", "programNoticesLoaded"]),

    titleTooltip() {
      return `
      Notices created here will appear on the dashboard of every member in your program.
      Only one notice may be set at a time. However, you may edit the text and end date of the current notice.
    `;
    }
  },

  mounted() {
    this.trackFeatureView("admin", "communications");
    const programId = this.$auth.user().programId;
    this.fetchProgramNotices();
    this.fetchAllFeaturedChallenge(programId);
  },

  methods: {
    ...mapActions("notices", ["fetchProgramNotice"]),
    ...mapActions("program", ["fetchFeaturedChallenge", "fetchArchivedEmails"]),
    ...mapActions("notices", ["fetchProgramNotices"]),
    ...mapActions("program", ["fetchAllFeaturedChallenge"]),

    async fetchArchived(payload) {
      let { page, sortColumn, sortOrder } = payload;
      try {
        let data = await this.fetchArchivedEmails({
          programId: this.$auth.user().programId,
          page,
          sortColumn,
          sortOrder
        });
        this.archivedEmails = data;
        this.archivedEmailsLoaded = true;
      } catch (error) {
        this.errorRetrievingEmail = true;
      }
    },

    tabSelected(tabIndex) {
      if (tabIndex === 1) {
        this.fetchArchived({});
      }
    },
    editNotice(notice) {
      this.editNoticeMode = true;
      this.noticeToEdit = notice;
      this.activeNoticeTab = 0;
    },
    goBackToNoticeList() {
      this.editNoticeMode = false;
      this.noticeToEdit = null;
      this.activeNoticeTab = 1;
    }
  }
};
</script>

<style lang="sass" scoped>
#communications-center
  .custom-collapse
    overflow: visible // for the tooltip
  .card-header
    min-height: 3.5rem
  .no-box-shadow
    box-shadow: none
  .box-shadow-transition
    transition: box-shadow 1s ease-in
  .challenge-report-card
    overflow: visible
</style>
